
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'editDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: 'edit' }) private type!: string
  @Prop({
    default: () => {
      return {}
    }
  }) private node!: any

  private switchValue=1;
  @Prop({ default: {} }) private allNodes!: any
  private isDisableSubmit = false
  private formData = {
    id: 0,
    label: '',
    parent_id: 0,
    describe: '',
    solution: '',
    switchValue: true
  }

  private rules = {
    label: [
      { required: true, message: '请输入问题类型的名称', trigger: 'blur' }
    ]
  }

  private parentOptions: any = []

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.issueTypeAddDialog
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      if (this.type === 'add' && this.node) {
        this.parentOptions = [{
          id: 0,
          label: '无'
        }].concat(this.allNodes)
        this.formData = {
          id: 0,
          label: '',
          parent_id: 0,
          describe: '',
          solution: '',
          switchValue: true
        }
      } else if (this.type === 'edit') {
        this.formData = Object.assign({}, this.node)
      }
    }
  }

  // 提交按钮触发
  private handleSubmit(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isDisableSubmit = true
        if (this.type === 'add') {
          this.addRequest()
        } else {
          this.editRequest()
        }
      } else {
        return false
      }
    })
  }

  // 新建保存
  private addRequest() {
    CONFIGAPI.addIssuesType({
      name: this.formData.label,
      parent: this.formData.parent_id,
      describe: this.formData.describe,
      solution: this.formData.solution,
      switch: this.formData.switchValue ? 1 : 0
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'issueTypeAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 编辑保存
  private editRequest() {
    CONFIGAPI.editIssuesType({
      name: this.formData.label,
      id: this.formData.id,
      describe: this.formData.describe,
      solution: this.formData.solution,
      switch: this.formData.switchValue ? 1 : 0
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'issueTypeAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'issueTypeAddDialog',
      value: false
    })
  }
}
